import React from 'react'
import { ProgressSpinner } from 'primereact/progressspinner'

/**
 * Spinner de espera por cima **apenas do conteudo da pagina** (a grade da listagem).
 *
 * Diferente do `LoadingOverlay`, que e `position: fixed` e cobre a tela inteira: aquele e para a
 * espera de uma acao que nao pode ser interrompida (estornar um lancamento). Este e para a espera
 * de uma consulta — paginar, ordenar, filtrar, voltar do formulario — em que o usuario continua
 * dono da tela: o menu, a barra de cima e a toolbar da listagem (Novo, Pesquisar) seguem
 * clicaveis, e so a grade fica velada enquanto os registros nao chegam.
 *
 * Velar a grade e proposital: evita disparar uma segunda paginacao/ordenacao em cima da consulta
 * que ainda esta em voo.
 *
 * Se posiciona em relacao ao `.page__content--loading` do `Page`, que e quem o renderiza.
 */
export const ContentLoadingOverlay = () => (
  <div className="page__content-overlay" aria-busy="true" aria-live="polite">
    <div className="page__content-overlay__spinner">
      <ProgressSpinner style={{ height: '50px' }} strokeWidth="8" fill="#EEEEEE" animationDuration=".5s" />
    </div>
  </div>
)
